import Footer from '@/components/layouts/Footer';
import { ROUTES } from '@/router/routes';
import { useLoginStore } from '@/stores/loginStore';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import CTASection from './CTASection';
import FeaturesSection from './FeaturesSection';
import LeftContent from './LeftContent';
import LoginForm from './LoginForm';
import StatsSection from './StatsSection';

export default function LandingPage() {
  const navigate = useNavigate();
  const { accessToken, loginData } = useLoginStore();

  // 토큰이 있고 로그인 상태라면 site-information으로 히스토리 없이 리디렉션
  useEffect(() => {
    if (accessToken && loginData.isLoggedIn) {
      navigate(ROUTES.SITE_INFORMATION, { replace: true });
    }
  }, [accessToken, loginData.isLoggedIn, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-cyan-50">
      {/* Hero Section with Background */}
      <div
        className="relative min-h-screen flex items-center justify-center"
        style={{
          backgroundImage: `url('/images/landing/hero-bg.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center ',
        }}
      >
        <div className="absolute inset-0 bg-black/15"></div>

        <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-12 mb-12">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Left Content */}
            <LeftContent />

            {/* Right Login Form */}
            <LoginForm />
          </div>
        </div>
      </div>

      <FeaturesSection />
      <StatsSection />
      <CTASection />
      <Footer />
    </div>
  );
}
